import Hook from "./libs/snake.lib.hook.js";
import Trace from "./libs/snake.lib.trace.js";
import AnalyticsService from "./libs/snake.lib.analytics.js";
import config from "./config.js";

export default class ComponentPremiumBanner {
    static modalI18nGenericOptions;

    static init = async () => {
        Trace.debug("Component _cmpPremiumBanner");

        const componentDom = document.querySelectorAll("." + config.routing.sections.premiumBanner.component);

        componentDom.forEach((component) => component.classList.remove("hidden"));

        await fetch(import.meta.env.CO_SNAKE_API_CACHED.replace("-test", "-qa") + "/api/v1/core/integration/product-info?sku=" + window.snakeCheckout.premiumSku + "&limit=1")
            .then((response) => response.json())
            .then((response) => {
                if (response.data && parseInt(response.data.quantity) > 0) {
                    componentDom.forEach((component) => {
                        component.querySelector(":scope > div > div > div:first-child").innerHTML = response.data.checkoutPremiumBanner.premiumOfferTypeText || "";

                        if (response.data.checkoutPremiumBanner.premiumOfferTypeImage?.src) {
                            const imgTag = component.querySelector("img");
                            imgTag.src = response.data.checkoutPremiumBanner.premiumOfferTypeImage.src;
                            imgTag.alt = response.data.checkoutPremiumBanner.premiumOfferTypeImage.alt || "";
                            imgTag.title = response.data.checkoutPremiumBanner.premiumOfferTypeImage.title || "";
                        } else {
                            component.classList.add("no-image");
                        }
                    });

                    /**
                     * Listener to intercept the Premium Banner user action
                     */
                    Hook.subscribe("_setPremiumVariant", () => {
                        AnalyticsService.checkoutPremiumBanner(() => {
                            window.location.href = "/" + config.countries[window.snakeCheckout.currentCountry].countryCode.toLowerCase() + "/subscribe?sku=" + window.snakeCheckout.premiumSku;
                        });
                    });

                    componentDom.forEach((component) => component.firstElementChild.classList.remove("hidden"));
                }
            })
            .catch((e) => {
                Trace.debug("premium banner error");
                Trace.debug(e);

                AnalyticsService.errorEvent("0_init", "technical", "snakeAPI | premium banner get product info error", e);
            });

        componentDom.forEach((component) => component.innerLoader(false));
    };
}
